import customPl from '@/translation/pl/index'
import validationMessages from '@/translation/pl/validationMessages.json'

export const messages = {
  pl: {
    ...customPl,
    validation: {
      ...validationMessages
    }
  }
}

export const additionalOptions = {
  locale: 'pl',
  globalInjection: true,
  legacy: false
}

export const i18nConfig = {
  messages,
  additionalOptions
}
